// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"ce976dfe","142":"94e1916c","166":"893666ee","168":"3d828598","282":"e15420a4","364":"b13fd209","443":"bacb973f","497":"8895b2a1","505":"39f68355","532":"883a0055","549":"ddbc43be","578":"22034c9d","637":"27444abe","775":"99590eb6","931":"b8fd8ac9"}[chunkId] + ".chunk.js";
};